import { ViewEncapsulation, Component, OnInit } from '@angular/core';
import { Student } from '../data-abstraction/student';
import { Group } from '../data-abstraction/group';

type ColumnType = { field: string,  sortable: boolean, filter: boolean };
type RowDataType = { namn: string, val_1: string, val_2: string, val_3: string };

@Component({
  selector: 'app-read-class',
  templateUrl: './read-class.component.html',
  styleUrls: ['./read-class.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReadClassComponent implements OnInit {
  public csvContent: string;
  public parsedCsv: [];
  columnDefs: Array<ColumnType>;
  rowData: Array<RowDataType>;

  constructor() { }

  ngOnInit(): void {
    const buhoData = localStorage.getItem('buho_data');

    if (buhoData !== undefined) {
      const group = new Group('', '');
      group.deserialize(buhoData);

      this.updateTable(group);
    }
  }

  onFileLoad(fileLoadedEvent): void {
    console.log('Called 1');
    const csvSeparator = ',';
    const textFromFileLoaded = fileLoadedEvent.target.result;
    console.log('Called 2');
    this.csvContent = textFromFileLoaded;
    // alert(textFromFileLoaded);

    console.log(textFromFileLoaded);

    const txt = textFromFileLoaded;
    const csv = [];
    const lines = txt.split('\n');
    lines.forEach( element => {
      const cols: string[] = element.split(csvSeparator);
      csv.push(cols);
    });
    // this.parsedCsv = csv;
    console.log(csv);

    const group = new Group(csv[1][1], csv[2][1]);

    for (const line of csv.slice(4, ) ) {
      if (line[0].length > 0) {
        const student = new Student(line[0], group.number_of_students);
        for (const selection of line.slice(1, ) ) {
          console.log(selection);
          student.add_selection(String(selection).trim());
        }
        group.add_student(student);
      }
    }

    group.build_relations();

    localStorage.clear();
    localStorage.setItem('buho_data', group.serialize);

    window.location.reload();
  }

  updateTable(group: Group): void {
    // Add data to table
    this.columnDefs = new Array<ColumnType>();
    this.columnDefs.push({ field: 'namn',  sortable: true, filter: false });
    this.columnDefs.push({ field: 'val_1', sortable: true, filter: false });
    this.columnDefs.push({ field: 'val_2', sortable: true, filter: false });
    this.columnDefs.push({ field: 'val_3', sortable: true, filter: false });

    this.rowData = new Array<RowDataType>();
    for ( const student of group.students ) {
      this.rowData.push({ namn: student.name, val_1: student.selections[0], val_2: student.selections[1], val_3: student.selections[2] });
    }

    document.getElementById("meas-group-item").innerHTML = "Klass: " + group.group_name;
    document.getElementById("meas-num-item").innerHTML = "Antal elever: " + group.number_of_students;
    document.getElementById("meas-question-item").innerHTML = "Fråga: " + group.question;
  }


  onFileSelect(input: HTMLInputElement): void {
    const files = input.files;
    const fileToLoad: Blob = new Blob();
    // var content = this.csvContent;
    if (files && files.length) {
        console.log('Filename: ' + files[0].name);
        console.log('Type: ' + files[0].type);
        console.log('Size: ' + files[0].size + ' bytes');

        const fileToRead = files[0];

        const fileReader = new FileReader();
        fileReader.onload = this.onFileLoad;

        fileReader.readAsText(files[0], 'UTF-8');
    }
  }

}
